import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const IngredientContext = createContext()

const IngredientProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    const getAllIngredients = async (currentPage, rowsPerPage, sortField, sortOrder, filter) => {
        try {
            const { data } = await axios.get(`${baseURL}/inventory/list?&sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&restaurant_id=${restaurantId}&filter=${filter !== '' ? filter : null}`, { headers })

            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getSingleIngredient = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/inventory/single-inventory/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createIngredient = async (ingredientDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/inventory/create`, ingredientDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Ingredient', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateIngredient = async (id, ingredientDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/inventory/update/${id}`, ingredientDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Ingredient', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteIngredient = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/inventory/delete/${id}`, { headers });
            if (data.error === false) {
                toast.current.show({ severity: 'success', summary: 'Ingredient', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const manageIngredientStock = async (id, ingredientDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/inventory/updateIngredientStock/${id}`, ingredientDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Ingredient', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Ingredient', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    return (
        <IngredientContext.Provider value={{ getAllIngredients, getSingleIngredient, createIngredient, updateIngredient, deleteIngredient, manageIngredientStock }}>
            {children}
        </IngredientContext.Provider>
    )
}

const useIngredient = () => useContext(IngredientContext)

export { useIngredient, IngredientProvider }